"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=(e,t)=>t(e),n=e=>{if(typeof e=="boolean"||typeof e>"u")return e};exports.getIsRequired=n;exports.getIsRequiredFromFunction=o;
